import React, { useState, useRef, useEffect } from 'react';
import './KeywordPill.css';

const TYP_LABELS = {
  tool: 'Tool',
  sprache: 'Sprache',
  methode: 'Methode',
};

export default function KeywordPill({ keyword, onErgaenzen }) {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const ref = useRef(null);

  const begriff = typeof keyword === 'object'
    ? (keyword.begriff || keyword.name || '')
    : String(keyword || '');
  const typ = keyword?.typ || null;
  const grund = keyword?.grund || null;
  const quelle = keyword?.quelle_im_text || null;

  const hasTooltip = !!(grund || quelle || onErgaenzen);

  useEffect(() => {
    if (!tooltipOpen) return;
    function handler(e) {
      if (ref.current && !ref.current.contains(e.target)) setTooltipOpen(false);
    }
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [tooltipOpen]);

  function handleMouseEnter() {
    if (begriff) {
      document.querySelectorAll('.cv-keyword-mark').forEach(el => {
        if (el.getAttribute('data-keyword')?.toLowerCase() === begriff.toLowerCase()) {
          el.classList.add('cv-keyword-mark--pulse');
        }
      });
    }
  }
  function handleMouseLeave() {
    document.querySelectorAll('.cv-keyword-mark--pulse').forEach(el => {
      el.classList.remove('cv-keyword-mark--pulse');
    });
  }

  if (!begriff) return null;

  return (
    <span
      ref={ref}
      className="kp-pill kp-pill--missing"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={() => hasTooltip && setTooltipOpen(v => !v)}
      role={hasTooltip ? 'button' : undefined}
      tabIndex={hasTooltip ? 0 : undefined}
      aria-expanded={hasTooltip ? tooltipOpen : undefined}
      onKeyDown={e => {
        if ((e.key === 'Enter' || e.key === ' ') && hasTooltip) {
          e.preventDefault();
          setTooltipOpen(v => !v);
        }
      }}
    >
      <span className="kp-label">{begriff}</span>

      {tooltipOpen && hasTooltip && (
        <span className="kp-tooltip" role="tooltip">
          {typ && <span className="kp-tooltip-tag">{TYP_LABELS[typ] || typ}</span>}
          {grund && <p className="kp-tooltip-grund">{grund}</p>}
          {quelle && <blockquote className="kp-tooltip-quelle">„{quelle}"</blockquote>}
          {onErgaenzen && (
            <button
              className="kp-tooltip-ergaenzen"
              onClick={(e) => {
                e.stopPropagation();
                setTooltipOpen(false);
                onErgaenzen(begriff, 'kenntnisse');
              }}
            >
              + Im Profil ergänzen
            </button>
          )}
        </span>
      )}
    </span>
  );
}
